// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback, useContext, useMemo } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { SIGNING_ACTIONS } from "@/lib/signing/types";
import { IPermissions } from "@/types/keycloak";
/** The signed-in user's signing permissions in the selected tenant. */
export var useSigningPermissions = function () {
    var isAuthorized = useContext(AuthContext).isAuthorized;
    var tenantId = useTenantStore()[0];
    var has = useCallback(function (permission) { return isAuthorized(true, tenantId, permission); }, [isAuthorized, tenantId]);
    return useMemo(function () { return ({
        canSign: function (action) {
            var info = SIGNING_ACTIONS[action];
            return info !== undefined && has(info.signPermission);
        },
        canCancel: has(IPermissions.SIGNING_REQUESTS_CANCEL),
        canReadRequests: has(IPermissions.SIGNING_REQUESTS_READ),
        canExportRequests: has(IPermissions.SIGNING_REQUESTS_EXPORT),
    }); }, [has]);
};
